import { render, staticRenderFns } from "./LogoCuisineConnectee.vue?vue&type=template&id=6b043c50&scoped=true&"
import script from "./LogoCuisineConnectee.vue?vue&type=script&lang=ts&"
export * from "./LogoCuisineConnectee.vue?vue&type=script&lang=ts&"
import style0 from "./LogoCuisineConnectee.vue?vue&type=style&index=0&id=6b043c50&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b043c50",
  null
  
)

export default component.exports